import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { removeWorkingAreaMessage, clearWorkingAreaMessages } from '@app/actions/customizeActions';

import WorkingAreaMessage from './WorkingAreaMessage';
import './WorkingAreaMessages.scss';

const WorkingAreaMessages = ({ workingAreaMessages, sideToolPanelExpanded, removeWorkingAreaMessage, clearWorkingAreaMessages }) => {
  workingAreaMessages.forEach(({ key, duration }) => {
    setTimeout(() => { removeWorkingAreaMessage(key) }, duration);
  });

  const handleClickAnywhere = () => clearWorkingAreaMessages();

  useEffect(() => {
      document.addEventListener("click", handleClickAnywhere);
      return () => {
          document.removeEventListener("click", handleClickAnywhere);
      };
  }, []);

  return (
    <div id="qau-working-area-messages-container" data-testid="qau-working-area-messages-container" className={classnames({ shrinked: sideToolPanelExpanded })}>
      {workingAreaMessages.map(({ key: locKey, values }, i) => (
      <WorkingAreaMessage
        key={`${i}-${locKey}`}
        locKey={locKey}
        values={values}
      />
    ))}
  </div>
  )
}

const mapStateToProps = ({
  customize: {
    customizeData: { workingAreaMessages, toolPanelOverlayLayout },
  },
  }) => ({
    workingAreaMessages,
    sideToolPanelExpanded: !!toolPanelOverlayLayout,
  });

const mapDispatchToProps = {
  removeWorkingAreaMessage,
  clearWorkingAreaMessages,
};

WorkingAreaMessages.propTypes = {
  workingAreaMessages: PropTypes.array.isRequired,
  sideToolPanelExpanded: PropTypes.bool.isRequired,
  removeWorkingAreaMessage: PropTypes.func.isRequired,
  clearWorkingAreaMessages: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkingAreaMessages);